export default "__VITE_ASSET__99bdaaa0__"